import { render, staticRenderFns } from "./NavegantesList.vue?vue&type=template&id=5e3badd1&scoped=true"
import script from "./NavegantesList.vue?vue&type=script&lang=js"
export * from "./NavegantesList.vue?vue&type=script&lang=js"
import style0 from "./NavegantesList.vue?vue&type=style&index=0&id=5e3badd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3badd1",
  null
  
)

export default component.exports